/** Galat pengukuran → pita tampilan. Turunan dari maeRidge, bukan konstanta desain. */
export type Ketelitian = {
  maeRidge: number;
  pitaTngf: number;
  pitaLobusPP: number;
  pitaMiPP: number;
};

/** Nilai referensi uji kestabilan 6.000 orang: MAE 4,90 → pita 15 / 2,7 / 1,35. */
export function ketelitianDariMae(maeRidge: number): Ketelitian {
  return {
    maeRidge,
    pitaTngf: maeRidge * (15 / 4.9),
    pitaLobusPP: maeRidge * (2.7 / 4.9),
    pitaMiPP: maeRidge * (1.35 / 4.9),
  };
}

export type KelompokMi = "menonjol" | "tengah" | "kurang menonjol";

export function kelompokMi(simpangan: number | null, pitaMiPP: number): KelompokMi | null {
  if (simpangan === null) return null;
  if (simpangan > pitaMiPP) return "menonjol";
  if (simpangan < -pitaMiPP) return "kurang menonjol";
  return "tengah";
}

/** Urutan tetap daftar kecerdasan — di dalam kelompok tidak diurutkan menurut nilai. */
export const URUTAN_KECERDASAN = [
  "Logical Mathematical",
  "Verbal Linguistic",
  "Musical Rhythmic",
  "Bodily Kinesthetic",
  "Visual Spatial",
  "Interpersonal",
  "Naturalist",
  "Intrapersonal",
] as const;

export const KETELITIAN_DEFAULT = ketelitianDariMae(4.9);
